import React from "react";
import { Link } from "react-router-dom";
import { FaHome, FaArrowLeft } from "react-icons/fa";

export default function NotFound() {
  return (
    <div
      className="d-flex align-items-center justify-content-center min-vh-100 position-relative overflow-hidden"
      style={{
        background:
          "linear-gradient(135deg, #f8fafc 0%, #eef2ff 50%, #ffffff 100%)",
      }}
    >
      {/* Background Blur */}
      <div
        className="position-absolute"
        style={{
          width: "400px",
          height: "400px",
          borderRadius: "50%",
          background: "rgba(34,197,94,0.08)",
          filter: "blur(80px)",
          top: "-100px",
          left: "-100px",
        }}
      />

      <div
        className="position-absolute"
        style={{
          width: "350px",
          height: "350px",
          borderRadius: "50%",
          background: "rgba(59,130,246,0.08)",
          filter: "blur(80px)",
          bottom: "-100px",
          right: "-100px",
        }}
      />

      <div className="container position-relative">
        <div className="row justify-content-center">
          <div className="col-lg-8 text-center">
            <div
              className=" mx-auto"
              style={{
                padding: "60px 30px",
                maxWidth: "700px",
              }}
            >
              <div
                className="fw-bold"
                style={{
                  fontSize: "clamp(5rem, 15vw, 10rem)",
                  lineHeight: 1,
                  background:
                    "linear-gradient(135deg, #dc2626, #ef4444, #f87171)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  textShadow: "0 10px 30px rgba(239,68,68,0.25)",
                }}
              >
                404
              </div>

              <h1
                className="fw-bold mt-3"
                style={{
                  color: "#0f172a",
                }}
              >
                Page Not Found
              </h1>

              <p
                className="text-muted mx-auto mt-3"
                style={{
                  maxWidth: "500px",
                  lineHeight: "1.8",
                }}
              >
                The page you're looking for doesn't exist or may have been
                moved. Let's get you back to where you need to be.
              </p>

              <div className="d-flex flex-column flex-sm-row justify-content-center gap-3 mt-4">
                <Link to="/" className="btn btn-success px-4 py-3 rounded-pill">
                  <FaHome className="me-2" />
                  Back to Home
                </Link>

                <button
                  className="btn btn-outline-dark px-4 py-3 rounded-pill"
                  onClick={() => window.history.back()}
                >
                  <FaArrowLeft className="me-2" />
                  Go Back
                </button>
              </div>

              <div className="mt-5">
                <small className="text-muted">Athees Info Solutions</small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
